import { Link } from "@tanstack/react-router"

export const NotFoundPage = () => (
  <div
    className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6"
    style={{
      background:
        "linear-gradient(173.77deg, #121639 9.13%, #111026 42.79%, #140D20 100%)",
    }}
  >
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      {Array.from({ length: 60 }).map((_, i) => (
        <div
          key={i}
          className="absolute rounded-full bg-white"
          style={{
            width: `${Math.random() * 2 + 1}px`,
            height: `${Math.random() * 2 + 1}px`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            opacity: Math.random() * 0.5 + 0.1,
            animation: `twinkle ${Math.random() * 4 + 3}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 5}s`,
          }}
        />
      ))}
    </div>

    <div
      className="pointer-events-none absolute right-0 left-0"
      style={{ bottom: "28%" }}
      aria-hidden="true"
    >
      <div
        className="mx-auto h-px w-full max-w-3xl"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(99, 102, 241, 0.15) 20%, rgba(99, 102, 241, 0.4) 50%, rgba(99, 102, 241, 0.15) 80%, transparent 100%)",
        }}
      />
    </div>

    <svg
      className="pointer-events-none absolute"
      style={{ bottom: "26%", left: "50%", transform: "translateX(-50%)" }}
      width="600"
      height="200"
      viewBox="0 0 600 200"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M 0 180 Q 150 180 250 120 Q 350 60 400 60 Q 450 60 500 30 L 520 20"
        stroke="url(#pathGrad)"
        strokeWidth="1.5"
        strokeDasharray="8 6"
        fill="none"
        className="animate-[dash_20s_linear_infinite]"
      />
      <g transform="translate(516, 16) rotate(-30)">
        <polygon points="0,-6 3,6 0,3 -3,6" fill="rgba(167, 139, 250, 0.9)" />
      </g>
      <circle cx="0" cy="180" r="3" fill="rgba(99, 102, 241, 0.4)" />
      <defs>
        <linearGradient id="pathGrad" x1="0" y1="0" x2="600" y2="0">
          <stop offset="0%" stopColor="rgba(99, 102, 241, 0.1)" />
          <stop offset="60%" stopColor="rgba(139, 92, 246, 0.5)" />
          <stop offset="100%" stopColor="rgba(167, 139, 250, 0.8)" />
        </linearGradient>
      </defs>
    </svg>

    <div className="relative z-10 text-center">
      <p
        className="mb-4 text-sm font-medium tracking-[0.3em] uppercase"
        style={{ color: "rgba(167, 139, 250, 0.7)" }}
      >
        Off course
      </p>

      <h1
        className="mb-2 text-[8rem] leading-none font-extralight tracking-tight"
        style={{ color: "rgba(255, 255, 255, 0.08)" }}
      >
        404
      </h1>

      <p
        className="-mt-10 mb-3 text-2xl font-light tracking-wide"
        style={{ color: "rgba(255, 255, 255, 0.85)" }}
      >
        Flight plan not found
      </p>

      <p
        className="mx-auto mb-10 max-w-sm text-sm leading-relaxed"
        style={{ color: "rgba(255, 255, 255, 0.35)" }}
      >
        The requested route doesn't exist in our system.
        <br />
        Let's get you back on track.
      </p>

      <Link
        to="/"
        className="group relative inline-flex items-center gap-2.5 rounded-full px-7 py-3 text-sm font-medium transition-all duration-300"
        style={{
          background: "rgba(99, 102, 241, 0.12)",
          border: "1px solid rgba(99, 102, 241, 0.25)",
          color: "rgba(167, 139, 250, 0.9)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(99, 102, 241, 0.2)"
          e.currentTarget.style.borderColor = "rgba(99, 102, 241, 0.5)"
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(99, 102, 241, 0.12)"
          e.currentTarget.style.borderColor = "rgba(99, 102, 241, 0.25)"
        }}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M6.5 12L2.5 8M2.5 8L6.5 4M2.5 8H13.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Return to dashboard
      </Link>
    </div>

    <style>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.1; }
          50% { opacity: 0.6; }
        }
        @keyframes dash {
          to { stroke-dashoffset: -200; }
        }
      `}</style>
  </div>
)
